// Angular
import { Component, OnInit, AfterViewInit } from '@angular/core';

// Services
import { AdminService } from 'src/app/services/admin/admin.service';
import { MessagesService } from 'src/app/services/message/messages.service';
import { NgxSpinnerService } from 'ngx-spinner';

// Others
import 'apexcharts';
import { WHAT } from '../classes';
import { tables } from '../../shared/data-tables';

@Component({
  selector: 'app-graph',
  templateUrl: './graph.component.html',
  styleUrls: ['./graph.component.less']
})
export class GraphComponent implements OnInit, AfterViewInit {
  private graph: ApexCharts;
  private countryGraph: ApexCharts;

  public showChart = {
    showYear: false,
    showMonthYear: false,
    showSummaryChart: true,
    showCountryChart: false
  };
  public allYears = [];
  public allTypes = tables;

  constructor(private admin: AdminService, private msg: MessagesService, private load: NgxSpinnerService) {
    this.allYears = this.generateYears();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.initGraph();
  }

  // generate all years from 2017
  private generateYears() {
    const allYears = [];
    const todaysYear = new Date().getFullYear();
    let startYear = 2017;

    for (let t = 0; startYear <= todaysYear; t++) {
      allYears.push(startYear);
      startYear++;
    }

    return allYears.sort((a, b) => {
      if (a < b) {
        return 1;
      }

      if (a > b) {
        return -1;
      }

      return 0;
    });
  }

  // activate loading spinner
  private spinner(action) {
    switch (action) {
      case 'show':
      case 's':
      case 'S':
        this.load.show('graph-spinner');

        break;

      case 'hide':
      case 'h':
      case 'H':
        this.load.hide('graph-spinner');

        break;
      default:
        break;
    }
  }

  // init graph
  private async initGraph() {
    // this.showChart.showSummaryChart = true;
    let data;
    try {
      if (WHAT.SummaryByYear) {
        data = await this.admin.GET(WHAT.SummaryByYear);

        const options = {
          chart: {
            type: 'line'
          },
          series: data,
          xaxis: {}
        };

        this.graph = new ApexCharts(document.querySelector('#summaryChart'), options);
        this.graph.render();
      }

    } catch (e) {
      console.log(e);
      this.msg.error(e);
    }
  }

  // get chart process
  public async getChartProcess(process) {
    this.spinner('S');

    switch (process) {
      case 'year':
        this.showChart.showYear = false;
        this.showChart.showMonthYear = false;
        this.showChart.showCountryChart = false;
        this.showChart.showSummaryChart = true;

        let data;
        try {
          data = await this.admin.GET(WHAT.SummaryByYear);
        } catch (e) {
          console.log(e);
          this.msg.error(e);
        }

        this.spinner('H');
        this.graph.updateOptions({
          chart: {
            type: 'line'
          },
          labels: []
        });
        this.graph.updateSeries(data, true);

        break;

      case 'month':
        this.graph.updateOptions({
          chart: {
            type: 'bar'
          },
          labels: []
        });

        this.showChart.showYear = true;
        this.showChart.showMonthYear = false;
        this.showChart.showCountryChart = false;
        this.showChart.showSummaryChart = true;

        this.chartData(this.allYears[0]);

        break;

      case 'monthYear':
        this.graph.updateOptions({
          chart: {
            type: 'line'
          },
          labels: []
        });

        this.showChart.showYear = false;
        this.showChart.showMonthYear = true;
        this.showChart.showCountryChart = false;
        this.showChart.showSummaryChart = true;

        this.chartMonthYearData('user');

        break;

      case 'country':

        this.showChart.showYear = false;
        this.showChart.showMonthYear = false;
        this.showChart.showCountryChart = true;
        this.showChart.showSummaryChart = false;

        this.chartCountry();

        break;

      default:
        break;
    }
  }

  public async chartMonthYearData(option) {
    this.spinner('S');
    let data;

    switch (option) {
      case 'all':
        const allData = [];

        for (let d = 0; d < tables.length; d++) {
          if (tables[d] !== 'all') {
            try {
              data = await this.admin.GET(WHAT.SummaryByMonthYear, null, tables[d]);
            } catch (e) {
              console.log(e);
              this.msg.error(e);
            }
            // remove/set as non array
            allData.push(data[0]);
          }
        }

        this.spinner('H');
        this.graph.updateSeries(allData, true);
        break;

      default:
        data = await this.admin.GET(WHAT.SummaryByMonthYear, null, option);
        this.spinner('H');
        this.graph.updateSeries(data, true);
        break;
    }
  }

  // to be used by month of each year
  public async chartData(year) {
    this.spinner('S');
    let data;
    try {
      data = await this.admin.GET(WHAT.SummaryByMonth, year);
    } catch (e) {
      console.log(e);
      this.msg.error(e);
    }

    this.spinner('H');
    this.graph.updateSeries(data, true);
  }

  // chart country
  private async chartCountry() {
    this.spinner('S');

    let data;
    try {
      data = await this.admin.GET(WHAT.Country);
    } catch (e) {
      console.log(e);
      this.msg.error(e);
    }

    const values = data[0].values as Array<number>;
    const allCountriesStr = data[0].countries;

    this.spinner('H');

    const options = {
      chart: {
        type: 'bar',
      },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      series: [{
        data: values
      }],
      xaxis: {
        categories: allCountriesStr,
      }
    };

    this.countryGraph = new ApexCharts(document.querySelector('#countryChart'), options);
    this.countryGraph.render();
  }

}
